export const GET_XPACKS_REQUEST = 'GET_XPACKS_REQUEST';
export const GET_XPACKS_SUCCESS = 'GET_XPACKS_SUCCESS';
export const GET_XPACKS_ERROR = 'GET_XPACKS_ERROR';
export const ADD_XPACK_REQUEST = 'ADD_XPACK_REQUEST';
export const ADD_XPACK_SUCCESS = 'ADD_XPACK_SUCCESS';
export const ADD_XPACK_ERROR = 'ADD_XPACK_ERROR';
export const UPDATE_XPACK_REQUEST = 'UPDATE_XPACK_REQUEST';
export const UPDATE_XPACK_SUCCESS = 'UPDATE_XPACK_SUCCESS';
export const UPDATE_XPACK_ERROR = 'UPDATE_XPACK_ERROR';
export const DELETE_XPACK_REQUEST = 'DELETE_XPACK_REQUEST';
export const DELETE_XPACK_SUCCESS = 'DELETE_XPACK_SUCCESS';
export const DELETE_XPACK_ERROR = 'DELETE_XPACK_ERROR';
export const DOWNLOAD_XPACK_REQUEST = 'DOWNLOAD_XPACK_REQUEST';
export const DOWNLOAD_XPACK_SUCCESS = 'DOWNLOAD_XPACK_SUCCESS';
export const DOWNLOAD_XPACK_ERROR = 'DOWNLOAD_XPACK_ERROR';
export const UPDATE_XPACKS_PAGINATION_PARAMS =
  'UPDATE_XPACKS_PAGINATION_PARAMS';
export const CANCEL_ADD_XPACK = 'CANCEL_ADD_XPACK';
export const CANCEL_UPDATE_XPACK = 'CANCEL_UPDATE_XPACK';

export const OVERRIDE_ALL_XPACK_INTENTS_REQUEST =
  'OVERRIDE_ALL_XPACK_INTENTS_REQUEST';
export const OVERRIDE_ALL_XPACK_INTENTS_COMPLETE =
  'OVERRIDE_ALL_XPACK_INTENTS_COMPLETE';

export const DISABLE_ALL_XPACK_INTENTS_REQUEST =
  'DISABLE_ALL_XPACK_INTENTS_REQUEST';
export const DISABLE_ALL_XPACK_INTENTS_COMPLETE =
  'DISABLE_ALL_XPACK_INTENTS_COMPLETE';
